import { assetPackIds } from "nemuru-components";
import { THEME_NAMES } from "./config";

export const formacionUniversitariaTheme = {
  zendeskCustomerSupport: true,
  themeName: THEME_NAMES.formacion_universitaria,
  logoUrl:
    "https://cdn.nemuru.com/assets/logos/formacion-universitaria-logo.svg",
  palette: {
    primary: {
      main: "#FF1E1E",
      contrastText: "#fff",
    },
    secondary: {
      main: "#000000",
      contrastText: "#fff",
    },
    text: {
      title: "#FF1E1E",
      primary: "#000",
      secondary: "#222222",
    },
    warning: {
      main: "#ffca28",
      contrastText: "#ffffff",
      light: "rgba(255, 202, 40, 0.15)",
    },
    info: {
      main: "#36a3f7",
      contrastText: "#ffffff",
      light: "#E1F1FD",
    },
    success: {
      main: "#4dd970",
      contrastText: "#ffffff",
      light: "rgba(73,217,106,0.15)",
    },
    error: {
      main: "#ef5957",
      contrastText: "#ffffff",
      light: "rgba(239,87,87,0.15)",
    },
    // additional colors
    dark: {
      main: "#920000",
      accent: "#000000",
      contrastText: "#ffffff",
      imageBackgroundOpacity: 0.8,
    },
    status: {
      active: "#4dd970",
      approved: "#43b46f",
      analysing: "#2ea3f2",
      sent: "#1c69d4",
      cancelled: "#d8d8d8",
      denied: "#dc0723",
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f2",
      200: "#eae9e6",
      300: "#dad9d6",
      400: "#b6b5b2",
      500: "#969593",
      600: "#6e6d6b",
      700: "#5a5a57",
      800: "#3c3b39",
      900: "#1b1b19",
    },
  },
  assetPackDefsId: assetPackIds.OUTLINED,
  background: "#fff",
  customBorderRadius: {
    button: 25,
    paper: 8,
    chip: 100,
  },
  typography: {
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
  },
};
